import { Color, Icon, Tooltip } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import type { EInvoiceIneligibilityReason } from '@features/invoices/enums/eInvoiceIneligibilityReason'

import { eInvoiceIneligibilityReasonToTranslationKey } from '../../constants/eInvoiceIneligibilityReasonToTranslationKey'
import * as Styled from './styles'

interface SendAsEInvoiceIneligibilityReasonsTooltipProps {
  reasons: EInvoiceIneligibilityReason[]
}

export const SendAsEInvoiceIneligibilityReasonsTooltip = ({
  reasons,
}: SendAsEInvoiceIneligibilityReasonsTooltipProps): ReactElement | null => {
  const { t } = useTranslation()

  if (reasons.length === 0) {
    return null
  }

  const hasBullets = reasons.length > 1

  return (
    <Tooltip
      placement="bottom"
      label={
        <>
          {t('external_invoices.editor.side_actions.send_as_e_invoice_ineligibility.header')}
          {reasons.map((reason) => (
            <Styled.IneligibilityReasonItem $hasBullet={hasBullets} key={reason}>
              {t(eInvoiceIneligibilityReasonToTranslationKey[reason])}
            </Styled.IneligibilityReasonItem>
          ))}
        </>
      }
    >
      <Icon color={Color.Grey700} icon="info" />
    </Tooltip>
  )
}
